import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsService } from '../api/services/settings';
import { State } from '../store/interfaces';
import {
  appSettingsErrorAction,
  appSettingsLoadedAction,
  requestAppSettingsAction,
} from '../store/reducers/app-settings';

export const useAppSettings = (settingsService: SettingsService) => {
  const appSettings = useSelector((state: State) => state.appSettings);
  const dispatch = useDispatch();
  const loadAppSettings = useCallback(async () => {
    dispatch(requestAppSettingsAction());
    try {
      const data = await settingsService.getAppSettings();
      dispatch(appSettingsLoadedAction(data));
    } catch (e) {
      dispatch(appSettingsErrorAction(e));
    }
  }, [dispatch, settingsService]);

  const reload = () => {
    loadAppSettings();
  };
  useEffect(() => {
    if (!appSettings.loaded && !appSettings.loading) {
      loadAppSettings();
    }
  }, [appSettings, loadAppSettings]);

  return {
    ...appSettings,
    reload,
  };
};
